import { FieldDefinitionTypes } from "@/shared/search/search.types.ts";
import { isHttpUrl } from "@/shared/utils/route-utils.ts";

export const isLinkDisplayField = (fieldType: FieldDefinitionTypes | undefined, value: string) => {
    return fieldType && fieldType === FieldDefinitionTypes.keyword && isHttpUrl(value);
};
